module.exports = __webpack_public_path__ + "static/img/rank_98.ccd4385.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_98.png
// module id = A+oJ
// module chunks = 0